module.exports = __webpack_public_path__ + "ac21dfc2d27db670fdde5103b3798ba3.pdf";